import { endOfDay, parseISO } from 'date-fns';
const state = {
  user: null,
  crol: null,
  srol: null,
  tcod: null,
  initFilter: {
    user: {
      // 컴포넌트 'v-autocomplete' 는 props 'value'가 'undefined' 일 때만 placehoder(label)를 보여준다.
      // 그래서 값이 없을 때에는 이렇게 해서 undefinded를 할당해주어야 placeholder 가 보여진다.
      //eslint-disable-next-line prettier/prettier
      user: (() => { return; })(),
      //eslint-disable-next-line prettier/prettier
      registrant: (() => { return; })(),
      regTerm: [parseISO('1970-01-02 00:00:00'), endOfDay(new Date())],
      logonTerm: [parseISO('1970-01-02 00:00:00'), endOfDay(new Date())],
      passTerm: [parseISO('1970-01-02 00:00:00'), endOfDay(new Date())],
      lockStatus: '',
    },
    crol: {
      //eslint-disable-next-line prettier/prettier
      crol: (() => { return; })(),
      //eslint-disable-next-line prettier/prettier
      registrant: (() => { return; })(),
      // 1970.01.01 00:00:00을 UTC 기준으로 변환하면 getTime() 시 음수값이 나온다.
      regTerm: [parseISO('1970-01-02 00:00:00'), endOfDay(new Date())],
      //eslint-disable-next-line prettier/prettier
      updater: (() => { return; })(),
      updTerm: [parseISO('1970-01-02 00:00:00'), endOfDay(new Date())],
    },
    srol: {
      //eslint-disable-next-line prettier/prettier
      srol: (() => { return; })(),
      //eslint-disable-next-line prettier/prettier
      registrant: (() => { return; })(),
      regTerm: [parseISO('1970-01-02 00:00:00'), endOfDay(new Date())],
      //eslint-disable-next-line prettier/prettier
      updater: (() => { return; })(),
      updTerm: [parseISO('1970-01-02 00:00:00'), endOfDay(new Date())],
    },
    tcod: {
      //eslint-disable-next-line prettier/prettier
      tcod: (() => { return; })(),
    },
  },
};

const mutations = {
  setUser(state, value) {
    state.user = {
      ...value,
    };
  },
  setCrol(state, value) {
    state.crol = {
      ...value,
    };
  },
  setSrol(state, value) {
    state.srol = {
      ...value,
    };
  },
  setTcod(state, value) {
    state.tcod = {
      ...value,
    };
  },
  resetStore(state, value) {
    state.user = {
      ...value.user,
    };
    state.crol = {
      ...value.crol,
    };
    state.srol = {
      ...value.srol,
    };
    state.tcod = {
      ...value.tcod,
    };
  },
};

const actions = {
  setUser({ commit }, value) {
    commit('setUser', value);
  },
  setCrol({ commit }, value) {
    commit('setCrol', value);
  },
  setSrol({ commit }, value) {
    commit('setSrol', value);
  },
  setTcod({ commit }, value) {
    commit('setTcod', value);
  },
  resetStore({ commit }, value) {
    commit('resetStore', value);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
